module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/owners/css/ownerchange.component.css
// module id = ./src/app/modules/owners/css/ownerchange.component.css
// module chunks = main